import { LabelStack } from '../label-stack';
import { PaperSize } from '../../../../shared/paper-size';
import { Orientation } from '../../../../enum/dto/orientation.enum';
import { LabelData } from '../../../../print-labels/label-data';
import { Type } from '@angular/core';
import { PrintLabelBackgroundComponent } from '../../../../../modules/print-cards/components/print-labels/backgrounds/print-label-background.component';
import { PrintLabelContentComponent } from '../../../../../modules/print-cards/components/print-labels/label-content/print-label-content.component';
import { Avery94200LabelStackContentComponent } from '../../../../../modules/print-cards/components/print-labels/label-content/avery-94200-label-stack-content/avery-94200-label-stack-content.component';

/**
 * https://www.avery.ca/en/avery-rectangle-labels-1-x-2-58-94200.html
 *
 * 1" x 2-5/8" (25.4mm x 66.7mm)
 * 30 labels per sheet
 */
export class Avery94200LabelStack extends LabelStack {
  getCardBackgroundComponent(labelData: LabelData): Type<PrintLabelBackgroundComponent> {
    return null;
  }

  getCardContentComponent(labelData: LabelData): Type<PrintLabelContentComponent> {
    return Avery94200LabelStackContentComponent;
  }

  getCardHeightInInches(): number {
    return 1;
  }

  getCardWidthInInches(): number {
    return 2.625;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    return 30;
  }

  nColumns(): number {
    return 3;
  }

  nRows(): number {
    return 10;
  }

  getLaserLabelPaperRowGapInInches(): number | null {
    return 0;
  }

  getLaserLabelPaperColumnGapInInches(): number | null {
    return 0.125; // ⅛ of an inch
  }

  cardOrientationOnPortraitPage(): Orientation {
    return Orientation.Landscape;
  }

  nonPerforatedBleedBorderInInches(): number {
    return 0;
  }
}
